<template>
  <div class="home">
    <h2>
      Users for Collection {{ collectionId }} (Users:
      {{ this.$store.state.usersForAbTesting.count }})
    </h2>
    <!-- Filtering -->
    <b-row>
      <b-col md="12" class="my-1">
        <b-form-group label-cols-sm="1" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter.platform"
              placeholder="by Platform"
              @keypress.enter="forceFilter"
            />
            <b-form-input
              v-model="filter.userId"
              placeholder="by UserId"
              @keypress.enter="forceFilter"
            />
            <b-form-input
              v-model="filter.appInstallId"
              placeholder="by appInstallId"
              @keypress.enter="forceFilter"
            />

            <b-input-group-append>
              <b-button
                :disabled="
                  !filter.appInstallId && !filter.userId && !filter.userId
                "
                @click="
                  filter = {};
                  forceFilter();
                "
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-container fluid>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="UsersForAbTestingTable"
        class="UsersForAbTestingTable"
      >
        <template v-slot:cell(active)="row">
          {{ row.value ? 'Yes' : 'No' }}
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            title="Delete User from Collection"
            @click="
              deleteUser({
                target: $event.target,
                userInfo: row.item
              })
            "
            >X</b-button
          >
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */

export default {
  data() {
    return {
      collectionId: '',
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: {
        platform: '',
        userId: '',
        appInstallId: ''
      }
    };
  },

  computed: {
    formIsActive: {
      get: function() {
        return !!this.form.active;
      },
      set: function(newValue) {
        this.form.active = newValue;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: false,
          sortDirection: 'desc'
        },
        {
          key: 'appInstallId',
          label: 'appInstallId',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'modelName',
          label: 'Model',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'version',
          label: 'version',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'whitelabel',
          label: 'Whitelabel',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'platform',
          label: 'Platform',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'userId',
          label: 'UserId',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false,
          class: 'text-center'
        }
      ];
    },
    totalRows() {
      return this.$store.state.usersForAbTesting.count;
    }
  },
  methods: {
    forceFilter() {
      this.$refs.UsersForAbTestingTable.refresh();
    },
    deleteUser({ userInfo }) {
      if (confirm('Delete this item?')) {
        const promise = this.$store.dispatch('removeUserFromAbTesting', {
          appInstallId: userInfo.appInstallId
        });
        return promise.then(() => {
          this.$refs.UsersForAbTestingTable.refresh();
        });
      }
    },
    items(ctx) {
      const currentFilter = Object.keys(this.filter).reduce(
        (acc, curr) =>
          this.filter[curr] ? { ...acc, [curr]: this.filter[curr] } : acc,
        {}
      );

      const id = +this.$router.history.current.params.collectionId;
      this.collectionId = id;
      const promise = this.$store.dispatch('getUsersForAbTesting', {
        id,
        ctx,
        filter: currentFilter
      });

      return promise.then(() => {
        return this.$store.state.usersForAbTesting.rows || [];
      });
    }
  }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.UsersForAbTestingTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
